import * as types from '../types/faqTypes';

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const faqReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_FAQ_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_FAQ_LIST_SUCCESS:
      return { ...state, loading: false, items: action.payload || [], error: null };
    case types.FETCH_FAQ_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default faqReducer;

